export default __webpack_public_path__ + "static/media/tree12.e4da3537.png";